<script setup lang="ts">
import AppContent from '@/components/AppContent.vue';
import AppShell from '@/components/AppShell.vue';
import AppSidebar from '@/components/AppSidebar.vue';
import AppSidebarHeader from '@/components/AppSidebarHeader.vue';
import { Toaster } from '@/components/ui/sonner';
import type { BreadcrumbItem } from '@/types';

type Props = {
    breadcrumbs?: BreadcrumbItem[];
};

withDefaults(defineProps<Props>(), {
    breadcrumbs: () => [],
});
</script>

<template>
    <AppShell variant="sidebar">
        <AppSidebar />
        <AppContent variant="sidebar" class="relative overflow-x-hidden">
            <!-- Soft cool wash so the canvas isn't a dead flat slab.
                 Cards/surfaces still own hierarchy; keep contrast low. -->
            <div
                class="pointer-events-none absolute inset-0 -z-0 dark:bg-[radial-gradient(120%_80%_at_10%_-10%,hsl(220_20%_18%/0.35),transparent_55%),radial-gradient(90%_60%_at_100%_0%,hsl(240_14%_14%/0.4),transparent_50%)]"
                aria-hidden="true"
            />
            <div class="relative z-10 flex min-h-full flex-col">
                <AppSidebarHeader :breadcrumbs="breadcrumbs" />
                <slot />
            </div>
        </AppContent>
        <Toaster />
    </AppShell>
</template>
